import script from "./PortraitsBox.vue?vue&type=script&setup=true&lang=js"
export * from "./PortraitsBox.vue?vue&type=script&setup=true&lang=js"

import "./PortraitsBox.vue?vue&type=style&index=0&id=09725f67&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09725f67"]])

export default __exports__